import { render } from "./reviewTaskDetail.vue?vue&type=template&id=6deaa1c5&scoped=true"
import script from "./reviewTaskDetail.vue?vue&type=script&lang=js"
export * from "./reviewTaskDetail.vue?vue&type=script&lang=js"

import "./reviewTaskDetail.vue?vue&type=style&index=0&id=6deaa1c5&scoped=true&lang=scss"

import exportComponent from "H:\\Environment_蓝宇\\Src\\GZXY\\GZEUA\\GZ_CQ_V2\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6deaa1c5"]])

export default __exports__